import { useMutation as e } from "@maat/store-hooks";
import { authApi as t } from "@maat/api-main";
//#region src/queries/login/useLoginRequestMutation.ts
var n = () => e({ mutationFn: t.loginRequest });
//#endregion
export { n as useLoginRequestMutation };
